import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Features section — collapsible toggle list.
 */
import { CollapsibleSection } from '../../shared/components/CollapsibleSection';
import { ToggleList } from '../../shared/components/ToggleList';
import featureFlags from '../../../backbone/lib/feature_flags.json';
export function FeaturesPanel({ form }) {
    return (_jsx(CollapsibleSection, { title: "Features", className: "features-panel", children: _jsx(ToggleList, { items: featureFlags, checked: form.featureCodes, onChange: form.toggleFeature }) }));
}
